import { useEffect, useState } from "react";
import RadnaMestaTabela from "./RadnaMestaTabela";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import RadnoMestoDokumenta from "./RadnoMestoDokumenta";
import Filter from "./Filter";
import DodavanjeRadnoMesto from "./DodavanjeRadnoMesto";
import ButtonsZeroChecked from "./ButtonsZeroChecked";
import ButtonsOneChecked from "./ButtonsOneChecked";
import ButtonsMoreChecked from "./ButtonsMoreChecked";
import RadnoMestoPrikaz from "./RadnoMestoPrikaz";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import axios from "axios";

const radnaMestaMock = [
  {
    id: "1",
    redniBroj: "1",
    naziv: "Direktor",
    rizik: "NE",
    sprema: "VSS",
    iskustvo: "5-10g",
    posebniUslovi: ["Uslov 1", "Uslov 2"],
    suma: 1,
    imena: ["Pera"],
  },
  {
    id: "2",
    redniBroj: "2",
    naziv: "Vozac motornog vozila",
    rizik: "DA",
    sprema: "SSS",
    iskustvo: "0.5-1g",
    posebniUslovi: [],
    suma: 16,
    imena: ["Zika", "Mika", "Laza"],
  },
  {
    id: "3",
    redniBroj: "3",
    naziv: "Cistacica",
    rizik: "NE",
    sprema: "0",
    iskustvo: "0",
    posebniUslovi: [],
    suma: 3,
    imena: ["Zika"],
  },
  {
    id: "4",
    redniBroj: "4",
    naziv: "Automehanicar za teretna vozila",
    rizik: "NEDEFINISANO",
    sprema: "SSS",
    iskustvo: "1-2g",
    posebniUslovi: ["uslov 5"],
    suma: 5,
    imena: ["Pera", "Zika"],
  },
];

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold",
  },
};

const filterDataInitial = {
  rizik: "",
  spreme_id: "",
  iskustvo: "",
};

function Pocetna() {
  const [radnaMesta, setRadnaMesta] = useState([]);
  const [filterData, setFilterData] = useState(filterDataInitial);

  const [isFilter, setIsFilter] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);
  const [isPoimenicno, setIsPoimenicno] = useState(false);

  const [isDodavanje, setIsDodavanje] = useState(false);
  const [radnoMestoIdEdit, setRadnoMestoIdEdit] = useState("");

  const [radnoMestoPrikazId, setRadnoMestoPrikazId] = useState("");
  const [radnaMestaDeleteIds, setRadnaMestaDeleteIds] = useState([]);

  const [checkedRows, setCheckedRows] = useState([]);

  const {
    dictionary,
    setSelectedNavbarDocument,
    setSelectedProcenaRizika,
    sisRadnihMestaDokumentaId,
    setSisRadnihMestaDokumentaId,
    baseUrl,
    loggedUser,
    selectedMainEntity,
  } = useGlobalContext();

  const filteredRadnaMesta = radnaMesta
    .filter(
      (rm) =>
        (!filterData.rizik ||
          filterData.rizik === "SVE" ||
          rm.rizik === filterData.rizik) &&
        (!filterData.spreme_id || rm.spreme_id === filterData.spreme_id) &&
        (!filterData.iskustvo || rm.iskustvo === filterData.iskustvo),
    )
    .sort((a, b) => (isCheckedSort ? a.suma - b.suma : b.suma - a.suma));

  // useEffect(() => {
  //   if (radnaMestaMock) {
  //     setRadnaMesta(radnaMestaMock);
  //   }
  // }, [radnaMestaMock]);
  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;

    const fetchWorkplaces = async () => {
      try {
        const { data } = await axios.post(`${baseUrl}/workplaces/read.php`, {
          company_id: selectedMainEntity.company_id,
        });
        if (data.status === 200) {
          const mapped = data.data.map((rm) => ({
            ...rm,
            id: String(rm.workplace_id),
            naziv: rm.workplace_name,
            rizik: rm.stepen_rizika || "NEDEFINISANO",
            sprema: rm.sprema || "0",
            iskustvo: rm.iskustvo || "-",
            posebniUslovi: rm.posebni_uslovi || [],
            suma: rm.suma || 0,
            imena: rm.imena || [],
          }));
          setRadnaMesta(mapped);
        }
      } catch (e) {
        console.error("Greška:", e);
      }
    };

    fetchWorkplaces();
    window.addEventListener("machineAdded", fetchWorkplaces);
    return () => window.removeEventListener("machineAdded", fetchWorkplaces);
  }, [selectedMainEntity]);

  const handleClickDokumenta = () => {
    setSisRadnihMestaDokumentaId(checkedRows[0]);
  };
  const handleCancelDokumenta = () => {
    setSisRadnihMestaDokumentaId("");
  };

  const handleClickNazad = () => {
    setSelectedNavbarDocument("");
    setSelectedProcenaRizika(0);
  };

  const handleFilterToggle = () => {
    setIsFilter((prev) => !prev);
    if (isFilter) {
      setIsPoimenicno(false);
      setFilterData(filterDataInitial);
    }
  };

  const handleDodaj = () => {
    setIsDodavanje(true);
  };

  const cancelDodaj = () => {
    setIsDodavanje(false);
    setRadnoMestoIdEdit("");
  };

  const handleOpenEdit = () => {
    setRadnoMestoIdEdit(checkedRows[0]);
  };

  const handleClosePrikaz = () => {
    setRadnoMestoPrikazId("");
  };

  const handleOpenPrikaz = () => {
    setRadnoMestoPrikazId(checkedRows[0]);
  };

  const handleOpenDelete = () => {
    setRadnaMestaDeleteIds(checkedRows);
  };

  const handleCancelDelete = () => {
    setRadnaMestaDeleteIds([]);
  };

  const handleConfirmDelete = () => {
    setRadnaMesta(
      radnaMesta.filter((rm) => !radnaMestaDeleteIds.includes(rm.id)),
    );
    setCheckedRows([]);
    handleCancelDelete();
  };

  if (isDodavanje || radnoMestoIdEdit)
    return <DodavanjeRadnoMesto cancel={cancelDodaj} id={radnoMestoIdEdit} />;

  if (sisRadnihMestaDokumentaId)
    return (
      <RadnoMestoDokumenta
        id={sisRadnihMestaDokumentaId}
        cancel={handleCancelDokumenta}
      />
    );

  if (radnoMestoPrikazId)
    return (
      <RadnoMestoPrikaz
        id={radnoMestoPrikazId}
        close={handleClosePrikaz}
        handleOpenEdit={handleOpenEdit}
      />
    );

  return (
    <div
      style={{
        backgroundColor: "#ccc",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          padding: "7px",
          backgroundColor: "rgb(255, 255, 255)",
          border: "1.5px solid #9f9f9f",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            backgroundColor: "white",
            padding: "7px",
            flex: 1,
            minHeight: 0,
          }}
        >
          <RadnaMestaTabela
            radnaMesta={filteredRadnaMesta}
            checkedRows={checkedRows}
            setCheckedRows={setCheckedRows}
            isPoimenicno={isPoimenicno}
            isCheckedSort={isCheckedSort}
            setIsCheckedSort={setIsCheckedSort}
          />
        </div>
        {isFilter ? (
          <Filter
            filterData={filterData}
            setFilterData={setFilterData}
            isPoimenicno={isPoimenicno}
            setIsPoimenicno={setIsPoimenicno}
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "15px",
            }}
          >
            <>
              <div onClick={handleDodaj} style={{ width: "20%" }}>
                <Button activation={true} style={styles.button}>
                  {dictionary["dodaj"]}
                </Button>
              </div>
              <div style={{ width: "40%" }}>
                <Button activation={true} style={styles.button}>
                  ORGANIZACIONA SEMA
                </Button>
              </div>
            </>
            {checkedRows.length === 1 && (
              <div onClick={handleClickDokumenta} style={{ width: "20%" }}>
                <Button activation={true} style={styles.button}>
                  {dictionary["dokumenta"]}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "15px",
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "30px", width: "25%" }}>
          245.
        </div>
        {(isFilter || checkedRows.length === 0) && (
          <ButtonsZeroChecked
            isFilter={isFilter}
            handleFilterToggle={handleFilterToggle}
            handleClickNazad={handleClickNazad}
          />
        )}
        {!isFilter && checkedRows.length === 1 && (
          <ButtonsOneChecked
            handleClickNazad={handleClickNazad}
            handleOpenEdit={handleOpenEdit}
            handleOpenPrikaz={handleOpenPrikaz}
            handleOpenDelete={handleOpenDelete}
          />
        )}
        {!isFilter && checkedRows.length > 1 && (
          <ButtonsMoreChecked handleOpenDelete={handleOpenDelete} />
        )}
      </div>

      {radnaMestaDeleteIds.length > 0 && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={
            checkedRows.length === 1
              ? dictionary["confirmDeleteRadnoMesto"]
              : dictionary["confirmDeleteRadnaMesta"]
          }
          handleCancel={handleCancelDelete}
        />
      )}
    </div>
  );
}

export default Pocetna;
